import { render, staticRenderFns } from "./LiveApplyForm.vue?vue&type=template&id=ff9b90d8&scoped=true&"
import script from "./LiveApplyForm.vue?vue&type=script&lang=js&"
export * from "./LiveApplyForm.vue?vue&type=script&lang=js&"
import style0 from "./LiveApplyForm.vue?vue&type=style&index=0&id=ff9b90d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9b90d8",
  null
  
)

export default component.exports